import { createSlice } from '@reduxjs/toolkit';

const anniversarySlice = createSlice({
  name: 'anniversary',
  initialState: {
    isSuccess: false,
    subscribedId: '',
    anniversaryList: [],
  },
  reducers: {
    // 기념일 등록 가능한 회사 등록
    createAnniversaryComp: () => {},
    createAnniversaryCompSuccess: (state, { payload }) => {
      state.isSuccess = true;
      state.subscribedId = payload.subscribedId;
    },
    updateAnniversaryCode: (state, { payload }) => {
      state.subscribedId = `HOL${payload}`;
    },
    createHolidaySuccess: (state, payload) => {
      state.isSuccess = payload;
    },
    createHolidayFail: state => {
      // temp isSuccess성공으로 변경해둠
      state.isSuccess = false;
    }, // 기념일 등록
    createHoliday: () => {},
    // 기념일 등록
    deleteHoliday: () => {},
    deleteHolidaySuccess: (state, payload) => {
      state.isSuccess = payload;
    },
    deleteHolidayFail: state => {
      // temp isSuccess성공으로 변경해둠
      state.isSuccess = false;
    },
    updateAnniversaryList: (state, { payload }) => {
      const newData = {
        startTime: payload.startTime.date,
        subject: payload.subject,
        calendarId: payload.calendarId,
        restDayYn: payload.restDayYn, // 휴일
        recurrence: payload.recurrence, // 반복
        uid: payload.uid,
      };
      const _anniversaryListArray = state.anniversaryList;
      _anniversaryListArray.push(newData);
      state.anniversaryList = _anniversaryListArray;
    },
    removeAnniversaryList: (state, { payload }) => {
      const _anniversaryListArray = state.anniversaryList.filter(item => item.uid !== payload.uid);
      state.anniversaryList = _anniversaryListArray;
    },
  },
});

export const {
  createAnniversaryComp,
  createAnniversaryCompSuccess,
  createHoliday,
  createHolidaySuccess,
  createHolidayFail,
  updateAnniversaryList,
  updateAnniversaryCode,
  removeAnniversaryList,
  deleteHoliday,
  deleteHolidaySuccess,
  deleteHolidayFail,
} = anniversarySlice.actions;
export default anniversarySlice.reducer;
